
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// import GET_SUBSCRIPTION_STATUS from "@/apollo/payment/GetSubscriptionStatus.gql";
// import GET_ADMIN_SUBSCRIPTION_REQUIRED_STATUS from "@/apollo/payment/GetAdminSubscriptionRequiredStatus.gql";

import ManagerAccessDeniedWarning from "@/components/alert/ManagerAccessDeniedWarning.vue"
import AuthWarning from "@/components/alert/AuthWarning.vue"
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

// import isSubscriptionActive from "@/helpers/payment/isSubscriptionActive";

import { Company, User } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import lambdaRequest from "@/helpers/lambdaRequest";
import { SubscriptionStatus } from "@/entities/payment/SubscriptionStatus";

@Component({
  components: {
    ManagerAccessDeniedWarning,
    AuthWarning,
    LoadingOverlay,
  },
  apollo: {
    /* Payment subscription checks commented out to make platform free
    $subscribe: {
      status: {
        query: GET_SUBSCRIPTION_STATUS,
        variables() {
          return {
            subscriptionId: this.company.subscriptions[0].id,
          };
        },
        result(result: any) {
          this.subscriptionStatus = result.data.subscription_by_pk.status;
        },
        skip() {
          return !this.isAdmin || !this.isSubscriptionExists || this.withoutSubscription;
        }
      },
    },
    adminSubscriptionRequired: {
      query: GET_ADMIN_SUBSCRIPTION_REQUIRED_STATUS,
      variables() {
        return {
          managerUserId: this.currentUser.id,
        };
      },
      update(data) {
        return data.user[0].subscription_required;
      },
      skip() {
        return !this.isManager || this.isSubscriptionExists;
      },
    }
    */
  },
})
export default class PaymentGuard extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, default: null }) readonly company!: Company | null;
  @Prop({ type: Boolean, required: true }) readonly authenticated!: boolean;

  subscriptionStatus: SubscriptionStatus | null = null;
  requestFailed: boolean = false;
  processing: boolean = false;
  // All users now have free access, subscription not required
  adminSubscriptionRequired: boolean = false;

  get isLoading(): boolean {
    // Simplified loading check since we disabled subscription checks
    return this.processing;
  }

  get isAccessDenied(): boolean {
    // Always allow access, payment requirements removed
    return false;
  }

  get isManagerAccessDenied(): boolean {
    // Always allow access for managers
    return false;
  }

  get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER;
  }

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  get isSubscriptionExists(): boolean {
    if (!this.company?.subscriptions) {
      return false;
    }

    return this.company.subscriptions.length > 0;
  }

  get isCompanySubscriptionActive(): boolean {
    // Always return true to grant access
    return true;
  }

  get withoutSubscription(): boolean {
    // All users are now treated as not requiring subscription
    return true;
  }

  /*
  @Watch("subscriptionStatus" )
  onSubscriptionStatusChange(): void {
    if (!this.isAdmin) {
      return;
    }

    const accessAllowed = isSubscriptionActive(this.subscriptionStatus);

    if (accessAllowed) {
      return;
    }

    this.$emit('refetch');
  }
  */

  async created(): Promise<void> {
    /* Payment check commented out to make platform free
    if (this.currentUser.role !== Roles.ADMIN) {
      return;
    }

    if (this.withoutSubscription) {
      this.processing = true;

      await lambdaRequest({
        lambdaName: "checkPaymentAccount",
      }).catch(() => {
        this.requestFailed = true;
      });

      this.processing = false;
      return;
    }

    const subscriptionStatus = this.company?.subscriptions[0]?.status;
    const subscriptionActive = isSubscriptionActive(subscriptionStatus);

    if (!subscriptionActive) {
      this.$router.push({
        name: RouteNames.CHOOSE_AUTH_SUBSCRIPTIONS,
      });
    }
    */
  }
}
